import { SessionComponent } from ".";
import * as React from "react";
import * as BS from "react-bootstrap";
import * as RS from "react-sortable-hoc";
import { BaseComponent } from "../../../../components/base";
import { Icon } from "../../../../components/generic";
import * as M from "../../../../models";
import { DateHelper, ReactHelper, Utility } from "../../../../utils";

interface OwnProps {
    event: M.Event.SubEvent;
    isSearch: boolean;
    onEventDeleteClick: (evt: M.Event.SubEvent) => void;
    onEventEditClick: (evt: M.Event.SubEvent) => void;
    onRsvpExportClick: (evtId: number) => void;
    onSessionAbstractClick: (abstractId: number) => void;
    onSessionEditClick: (parent: M.Event.SubEvent, evt?: M.Event.SubEvent) => void;
    onSessionsSorted: (parentId: number, sortEnd: RS.SortEnd) => void;
}

interface OwnState {
    open: boolean;
}

export class EventComponent extends BaseComponent<OwnProps, OwnState> {

    private DragHandle = RS.SortableHandle(() => <div className="schedule-draghandle" title="Drag session to desired sequence">
        <Icon icon="ellipsis-v" />
    </div>);

    private SortableItem = RS.SortableElement((item: { evt: M.Event.SubEvent; session: M.Event.SubEvent }) => (
        <li>
            <SessionComponent
                dragHandle={this.DragHandle}
                isSearch={this.props.isSearch}
                session={item.session}
                onRsvpExportClick={(evtId) => this.props.onRsvpExportClick(evtId)}
                onSessionAbstractClick={(this.props.onSessionAbstractClick)}
                onSessionDeleteClick={this.props.onEventDeleteClick}
                onSessionEditClick={(evtSession) => this.props.onSessionEditClick(item.evt, evtSession)}
            />
        </li>
    ));

    private SortableList = RS.SortableContainer((container: { evt: M.Event.SubEvent; sessions: M.Event.SubEvent[] }) => {
        return <ol className="schedule-subevents">
                {container.sessions.map((s, i) => <this.SortableItem evt={container.evt} session={s} key={i} index={i} />)}
            </ol>;
    });

    public constructor(props: any) {
        super(props);
        this.state = {
            open: false,
        };
    }

    public componentDidUpdate(prevProps: Readonly<OwnProps>) {
        if (prevProps.event.id !== this.props.event.id)
            this.setStateAsync({ ...this.state, open: false });
    }

    public render() {
        const evt = this.props.event;

        const evtTitle = evt.children.length
            ? <h3 className="schedule-event-title">
                <a
                    href="#"
                    dangerouslySetInnerHTML={{ __html: evt.title }}
                    onClick={(e) => { ReactHelper.emptyClick(e); this.toggleOpen(); }}
                />
            </h3>
            : <h3 className="schedule-event-title" dangerouslySetInnerHTML={{ __html: evt.title }} />;

        return <>
                <div className="schedule-event">
                    <div className="schedule-event-time" dangerouslySetInnerHTML={{
                        __html: DateHelper.displayTimeRange(
                            Utility.fromApiDateAsMoment(evt.startDate),
                            Utility.fromApiDateAsMoment(evt.endDate),
                            "&ndash;",
                        ),
                    }}/>
                    <div className="schedule-event-summary">
                        {evtTitle}
                        <ul className="schedule-event-details">
                            <li title={DateHelper.displayTimeDuration(evt.duration, false)}>
                                {DateHelper.displayTimeDuration(evt.duration, true)}
                            </li>
                            {evt.type ? <li>{evt.type}</li> : null}
                            {evt.locationName ? <li>{evt.locationName}</li> : null}
                            {evt.canRsvp
                                ? <li>
                                    <Icon icon="check" /> RSVP{" "}
                                    {evt.seatsLeft < (evt.seatsAvailable || 0)
                                        ? <span>(<a href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.props.onRsvpExportClick(evt.id); }}>
                                            {(evt.seatsAvailable || 0) - evt.seatsLeft} of {evt.seatsAvailable}
                                        </a>)</span>
                                        : null}
                                </li>
                                : null}
                        </ul>
                    </div>
                    <ul className="schedule-event-actions">
                        <li>
                            <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.props.onSessionEditClick(evt); }} title="Add session">
                                <Icon icon="plus" />
                            </a>
                        </li>
                        <li>
                            <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.props.onEventEditClick(evt); }} title="Edit">
                                <Icon icon="pencil" />
                            </a>
                        </li>
                        <li>
                            <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.props.onEventDeleteClick(evt); }} title="Delete">
                                <Icon icon="trash" />
                            </a>
                        </li>
                    </ul>
                </div>
                <BS.Collapse in={this.state.open || this.props.isSearch}>
                    <div>
                        <this.SortableList
                            evt={evt}
                            helperClass="schedule-subevents sorting"
                            lockAxis="y"
                            sessions={evt.children}
                            onSortEnd={(sort, e) => this.props.onSessionsSorted(evt.id, sort)}
                            transitionDuration={150}
                            useDragHandle
                        />
                    </div>

                    {/* <ol className="schedule-subevents open">
                        {evt.children.map((session: M.Event.SubEvent, i) => (
                            <li key={i}>
                                <SessionComponent
                                    key={i}
                                    session={session}
                                    onSessionEditClick={(evtSession) => this.props.onSessionEditClick(evt, evtSession)}
                                />
                            </li>
                        ))}
                    </ol> */}
                </BS.Collapse>
            </>;
    }

    private toggleOpen() {
        this.setStateAsync({ ...this.state, open: !this.state.open });
    }
}

interface NoEventsComponentProps {
    onEventAddClick: () => void;
}

export const NoEventsComponent: React.SFC<NoEventsComponentProps> = (props) => {
    return <div className="schedule-event">
        <div className="schedule-event-time" />
        <div className="schedule-event-summary">
            <h3 className="schedule-event-title">No events have been added yet.</h3>
            <ul className="schedule-event-details">
                <li>
                    <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); props.onEventAddClick(); }}>
                        <Icon icon="plus" /> Add event
                    </a>
                </li>
            </ul>
        </div>
    </div>;
};



// WEBPACK FOOTER //
// ./src/containers/adminEvent/editCalendar/components/EventComponent.tsx